'use client'

import React, { Fragment } from 'react'

import ContentModelLogic from '@/components/LandingPage/ContentModel/ContentModelLogic'
import { Props as OptimizerProps } from '@/components/Optimizer/ClientOptimizer'
import { CampaignType } from '@/types/Campaign'
import { ContentModelType } from '@/types/ContentModel/ContentModel'
import { ProductType } from '@/types/product'

type Props = {
  contentModels: ContentModelType[]
  baseline?: boolean
  optimizer?: OptimizerProps
  firstView: boolean
  product: ProductType | null
  campaign: CampaignType | null
  afterSubmit: (() => void) | null
}

export default function ContentModels({
  contentModels,
  baseline = false,
  optimizer = {},
  product,
  campaign,
  firstView,
  afterSubmit,
}: Props) {
  return contentModels.map((contentModel, index) => {
    return (
      <Fragment key={index}>
        <ContentModelLogic
          contentModel={contentModel}
          baseline={baseline}
          optimizer={optimizer}
          product={product}
          campaign={campaign}
          firstView={firstView ? index == 0 : false}
          afterSubmit={afterSubmit}
        />
      </Fragment>
    )
  })
}
